module.exports = __webpack_public_path__ + "static/media/Bus_Economico_660x288px.33f84b58.jpg";